import { render } from "./GroupManagement.vue?vue&type=template&id=6245d8b1&scoped=true"
import script from "./GroupManagement.vue?vue&type=script&lang=js"
export * from "./GroupManagement.vue?vue&type=script&lang=js"

import "./GroupManagement.vue?vue&type=style&index=0&id=6245d8b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6245d8b1"]])

export default __exports__